import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';
import { VehicleIssueController } from './vehicle-issue-controller';
import { VehicleissueEntity } from './vehicle-issue-entity';
import { VehicleIssueService } from './vehicle-issue-service';
import { FileUploadEntity } from './file-upload-entity';

@Module({
  imports: [TypeOrmModule.forFeature([VehicleissueEntity,FileUploadEntity])],
  controllers: [VehicleIssueController],
  providers: [VehicleIssueService,ApplicationExceptionHandler],
})
export class VehicleIssueModule {}